import _ from 'lodash';

export const trackEvent = (name, data) => {
  if (typeof window !== 'undefined' && window._satellite) {
    window._satellite.track(name, data);
  }
};

export const mergeDigitalData = (...data) => {
  if (typeof window !== 'undefined') {
    _.merge(window.digitalData, ...data);
  }
};

// this is expected to match generate_destination in app/models/analytics/attributes_generator.rb
export const dataTrackAttribute = (path, locale = 'en-US', withDomainPrefix = true, domainPrefix = 'oc') => {
  const regExp = new RegExp(`^\/${locale}`, 'i');
  const enUsRegExp = /^\/en-us/i;
  const pathWithoutQuery = (path || '').split('?')[0];
  let pathWitoutLocale = pathWithoutQuery.replace(regExp, '');
  pathWitoutLocale = pathWitoutLocale.replace(enUsRegExp, '');
  const pathFragments = _.filter(pathWitoutLocale.replace(/_/g, '-').split('/'), _.size);
  const response = withDomainPrefix ? [domainPrefix, ...pathFragments].join(' | ') : pathFragments.join(' | ');
  if (['oc', 'paroc', 'vidawool', 'fleetwoodusa'].includes(response)) {
    return `${domainPrefix} | home page`;
  }
  return response;
};

// see also app/helpers/application_helper.rb map_path_fragment_from_domain
export const mapPathFragmentFromDomain = () =>
  ({
    'www.owenscorning.com': 'oc',
    'www.vidawool.com': 'vidawool',
    'www.paroc.com': 'paroc',
    'www.fleetwoodusa.com': 'fleetwoodusa',
    // eslint-disable-next-line no-undef
  }[PB_SITE] || 'oc');
